import { AxiosInstance } from 'axios';
import {
  BillsConfirmRepository,
  BillsConfirmRequest,
  BillsConfirmResponse,
} from '@/model/repository/manager/bill/BillsConfirmRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): BillsConfirmRepository => ({
    save(payload: BillsConfirmRequest): BillsConfirmResponse {
      return Repository.post(`${resource}`, payload);
    },
  });
